<ion-item lines="none" class="bkg-transparent">
  <ion-icon class="m-a" [src]="footerLogoPath" [ngStyle]="footerLogoStyle"></ion-icon>
</ion-item>
